import React, { useEffect, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Lightbox from 'react-image-lightbox';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import Button from '@mui/material/Button';

import Grid from '@mui/material/Grid';
import Main from 'layouts/Main';

import { Typography } from '@mui/material';
import Container from 'components/Container';
import { Sidebar2023 } from 'views/SchoolProgram2023/components';
import Sidebar2025 from '../SchoolProgram2023/components/Sidebar2025';
import Archive2022 from '../SchoolProgram2023/components/Archive2022';
import { Sidebar2026 } from '../SchoolProgram2023/components';


const SocialandEmotional = () => {
    const theme = useTheme();
    const [currentImage, setCurrentImage] = useState(0);
    const [viewerIsOpen, setViewerIsOpen] = useState(false);

    const openLightbox = (index) => {
        setCurrentImage(index);
        setViewerIsOpen(true);
    };

    const closeLightbox = () => {
        setCurrentImage(0);
        setViewerIsOpen(false);
    };

    const isMd = useMediaQuery(theme.breakpoints.up('md'), {
        defaultMatches: true,
    });
    const [config, setConfig] = useState({ base_image_url_2026: '' });
    useEffect(() => {
      fetch('/config.json')  // For Gatsby, this will resolve to /config.json from the static folder
        .then(response => response.json())
        .then(data => setConfig(data))
        .catch(error => console.error('Error fetching config:', error));
    }, []);
    
    const p1 = `${config.base_image_url_2026}/home/events-activities/school-programs/social-and-emotional/1.webp`;
    const p2 = `${config.base_image_url_2026}/home/events-activities/school-programs/social-and-emotional/2.webp`;
    const p3 = `${config.base_image_url_2026}/home/events-activities/school-programs/social-and-emotional/3.webp`;
    const p4 = `${config.base_image_url_2026}/home/events-activities/school-programs/social-and-emotional/4.webp`;
    const p5 = `${config.base_image_url_2026}/home/events-activities/school-programs/social-and-emotional/5.webp`;





    const photos = [
       
        {
            src: p1,
            source: p1,
            rows: 1,
            cols: 1,
        },
        {
            src: p2,
            source: p2,
            rows: 1,
            cols: 1,
        },
        {
            src: p3,
            source: p3,
            rows: 1,
            cols: 1,
        }, 
        {
            src: p4,
            source: p4,
            rows: 1,
            cols: 1,
        },
         {
            src: p5,
            source: p5,
            rows: 1,
            cols: 1,
        },
        
    ];

    return (
        <Main>
            <Container>
                <Grid container spacing={4}>
                    <Grid item xs={12} md={8}>
                        <Box>

                            <Box >
                                <Typography variant='h4' align='center'>
                               CBP WORKSHOP ON SOCIAL AND EMOTIONAL LEARNING
                                </Typography>
                                <Typography
                                    fontSize="x-small"
                                ><br /><br />
                                  Date: 20 May 2026
                                </Typography>
                                {/* <Typography
                                variant={'h6'}
                                color={'primary'}
                                align={'center'}
                                fontWeight={'normal'}
                            ><br />
                                “If you believe in yourself and have dedication and determination and never quit, you'll be a winner. The price of victory is high but so are the rewards.”

                                <br />
                            </Typography> */}

                                <br />
                               <Typography variant={'subtitle1'} align={'justify'}>
National Public School organized a CBSE Capacity Building Programme (CBP) on Social Emotional Learning (SEL)
 for teachers on Wednesday, 20 May 2026. The programme aimed at equipping educators with effective strategies to foster students’
 emotional well-being, interpersonal skills, and holistic development within the classroom environment.
  <br></br>

The workshop was conducted by distinguished resource persons, Shanthi V, Principal of MS Ramaiah Vidyaniketan School,
 and Saritha Santosh a PGT English from Delhi Public School North. Their expertise and
 interactive approach made the sessions engaging, insightful and highly beneficial for the participants.

  <br></br>
  The workshop was systematically divided into four comprehensive sessions, each focusing on a significant aspect of Social Emotional Learning.

  <br></br>
The first session introduced the concept of Social and Emotional Learning and emphasised its importance in the overall growth and development of students. The resource persons elaborated on the benefits of SEL in creating emotionally balanced, empathetic and responsible individuals. The session highlighted the five core competencies of SEL — Self-Awareness, Self-Management, Social Awareness, Relationship Skills, and Responsible Decision-Making. Through discussions and collaborative activities, teachers gained a deeper
 understanding of how these competencies contribute to building positive learning environments and nurturing students’ emotional intelligence.
  <br></br>
  The second session focused on classroom management and student engagement through Social and Emotional Learning practices. Various strategies and techniques that can be incorporated into classroom teaching were discussed in detail. The resource persons demonstrated methods to create inclusive and emotionally safe classrooms where students feel valued and motivated to participate actively. Teachers were introduced to practical activities, reflective exercises,
   group interactions and communication techniques that help strengthen emotional connections and improve classroom relationships.
     <br></br>
The third session concentrated on integrating SEL into subject teaching. The facilitators explained how social and emotional competencies can be seamlessly embedded into daily lesson plans and classroom transactions across subjects. Teachers were encouraged to adopt student-centred approaches that promote critical thinking, empathy, collaboration and responsible behaviour.
 The session provided examples of integrating SEL objectives into academic content, thereby making learning more meaningful and holistic.
      <br></br>
The fourth and final session dealt with assessing social-emotional practices and formulating an action plan for implementation. The resource persons guided the participants on evaluating students’ social and emotional growth using observation, reflection, and feedback mechanisms. Teachers also worked collaboratively to design actionable plans for incorporating SEL practices effectively within their classrooms and school culture. The session emphasized the importance of continuous reflection,
 consistency, and collaboration among educators in fostering social and emotional competencies among students.
      <br></br>

 The Capacity Building Programme proved to be highly enriching and informative. It provided educators with valuable insights, practical strategies, and a renewed perspective on the importance of Social Emotional Learning in education. The workshop reinforced the role of teachers in nurturing emotionally resilient, socially responsible
  and compassionate learners who are well-equipped to face the challenges of the modern world.
        <br></br>

</Typography>
                            </Box>
                            <Typography
                                variant={'h6'}
                                color={'primary'}
                                align={'center'}
                                fontWeight={'normal'}
                            ><br />
             Equipping educators with the tools to inspire emotional well-being and lifelong success.
                            </Typography>

                            <Box>
                                <ImageList
                                    variant="quilted"
                                    cols={2}
                                    rowHeight={isMd ? 200 : 100}
                                    gap={isMd ? 16 : 4}
                                >
                                    {photos.map((item, i) => (
                                        <ImageListItem key={i} cols={item.cols} rows={item.rows}>
                                            <LazyLoadImage
                                                height={'100%'}
                                                width={'100%'}
                                                src={item.src}
                                                alt="..."
                                                effect="blur"
                                                onClick={() => openLightbox(i)}
                                                style={{
                                                    objectFit: 'cover',
                                                    filter:
                                                        theme.palette.mode === 'dark' ? 'brightness(0.7)' : 'none',
                                                    cursor: 'poiner',
                                                    borderRadius: 8,
                                                }}
                                            />
                                        </ImageListItem>
                                    ))}
                                </ImageList>
                            </Box>
                            {viewerIsOpen && (
                                <Lightbox
                                    mainSrc={photos[currentImage].src}
                                    nextSrc={photos[(currentImage + 1) % photos.length].src}
                                    prevSrc={
                                        photos[(currentImage + photos.length - 1) % photos.length].src
                                    }
                                    onCloseRequest={() => closeLightbox()}
                                    onMovePrevRequest={() =>
                                        setCurrentImage((currentImage + photos.length - 1) % photos.length)
                                    }
                                    onMoveNextRequest={() =>
                                        setCurrentImage((currentImage + 1) % photos.length)
                                    }
                                    reactModalStyle={{ overlay: { zIndex: 1500 } }}
                                />
                            )}
                        </Box>
                    </Grid>
                    <Grid item xs={12} md={4}>
                    <Box marginBottom={4}>
                            <Sidebar2026/>
                        </Box> 
                        <Box marginBottom={4}>
                            <Archive2022/>
                        </Box>

                    </Grid>
                </Grid>
            </Container>
        </Main>

    );
};

export default SocialandEmotional;